import React from 'react';
import { Phone, Truck, MapPin, CreditCard, Check } from 'lucide-react';

interface Step {
  id: string;
  title: string;
  icon: React.ReactNode;
}

interface CheckoutProgressProps {
  currentStep: string;
  steps: Step[];
  formData: {
    shippingMethod: string;
  };
  orderId: string | null;
}

export function CheckoutProgress({ currentStep, steps, formData, orderId }: CheckoutProgressProps) {
  const getVisibleSteps = () => {
    return steps.filter(step => 
      !(step.id === 'address' && formData.shippingMethod === 'Tulen ise järgi') &&
      !(step.id === 'confirmation' && !orderId)
    );
  };

  const getCurrentStepIndex = () => {
    const visibleSteps = getVisibleSteps();
    return visibleSteps.findIndex(step => step.id === currentStep);
  };

  const getTotalSteps = () => {
    return getVisibleSteps().length;
  };

  return (
    <div className="mb-12">
      <div className="relative">
        <div className="absolute left-0 top-1/2 w-full h-0.5 bg-gray-200 -translate-y-1/2">
          <div 
            className="h-full bg-[#4FC1E9] transition-all duration-500"
            style={{
              width: `${(getCurrentStepIndex() / (getTotalSteps() - 1)) * 100}%`
            }}
          ></div>
        </div>
        <div className="relative flex justify-between">
          {getVisibleSteps().map((step, index) => {
            const isActive = getCurrentStepIndex() >= index;
            
            return (
              <div 
                key={step.id} 
                className="flex flex-col items-center"
              >
                <div 
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center z-10
                    transition-all duration-500
                    ${isActive ? 'bg-[#4FC1E9] text-white' : 'bg-white border-2 border-gray-200 text-gray-400'}
                  `}
                >
                  {step.icon}
                </div>
                <span className={`
                  mt-2 text-sm font-medium whitespace-nowrap
                  ${isActive ? 'text-[#4FC1E9]' : 'text-gray-500'}
                `}>
                  {step.title}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}